import SelectInput from 'components/forms/inputs/rhf-inputs/SelectInput';
import { getValidOptionsFromClassifier } from 'utils/formUtil';
import { MatterFormState } from './useMatterForm';

/** Accounting details: the revenue type. */
export const AccountingFields = ({ form }: { form: MatterFormState }): JSX.Element => {
    const { control, setValue } = form.methods;
    const { classifiers, isLoadingNewClientData } = form;

    return (
        <>
            <SelectInput
                setValue={setValue}
                control={control}
                label="matters.accounting-revenue-type"
                placeholder="matters.select-accounting-revenue-type"
                name="accountingRevenueType"
                options={
                    (getValidOptionsFromClassifier(classifiers['ACCOUNTING_REVENUE_TYPE']) as {
                        label: string;
                        value: string;
                    }[]) ?? []
                }
                getOptionLabel="label"
                getOptionIdentifier="value"
                required
                disabled={isLoadingNewClientData}
            />
        </>
    );
};
